module.exports = __webpack_public_path__ + "media/images/icons/outlined/insert-row-below-5e5b071d33941e8d1d227e9fc25662d8.svg";